import Head from 'next/head';
import { useRouter } from 'next/router';

import Metatag from 'app/components/metaTag';

export default function PrivacyPolicy() {
  const { asPath } = useRouter();

  return (
    <div>
      <Head>
        <title>Privacy Policy - VLink</title>
        <meta name="description" content={'Vlink Description'} />
        <meta name="og:description" content={'Vlink Description'} />
        <meta name="og:title" content={'Privacy Policy - Vlink'} />

        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_BASE_URL}${asPath}`}
        />

        <Metatag content={`https://www.vlinkinfo.com/img/logopng.png`} />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="use-credentials"
        />
      </Head>
      <section className="py-[55px] mt-20">
        <div className="container">
          <div className="grid grid-cols-12 gap-10">
            <div className="col-span-12 w-full">
              <h1 className="font-bold md:text-[40px] text-[30px] mb-5  text-[#000000] ">
                Privacy Policy <span className="text-company">Statement</span>
              </h1>
            </div>
            <div className="col-span-12">
              <div className="mb-[30px]">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  Effective Date: November 20, 2017
                </h4>
                <h4 className="text-xl font-bold  text-[#000000] mb-4 ">
                  Updated: March, 2025
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  VLink, Inc. respects the privacy of our affiliates, customers,
                  and visitors to our website, www.vlinkinfo.com. While offering
                  our website users the benefits and convenience of web-based
                  technologies, we also strive to employ practices that ensure
                  the information we collect about affiliates, customers, and
                  visitors is used conscientiously and appropriately.
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6">
                  This Privacy Policy Statement outlines the use of personally
                  identifiable information collected on the Website. It does not
                  apply to other websites referenced by us in print, online,
                  SMS, or email communications.
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6">
                  We will not share your opt-in status for an SMS campaign with
                  any third party for purposes unrelated to providing you with
                  the services of that campaign. However, we may share your
                  personal data, including your SMS opt-in or consent status,
                  with third parties that help us provide our messaging
                  services, including but not limited to platform providers,
                  phone companies, and other vendors assisting in the delivery
                  of text messages.
                </p>
              </div>
              <div className="mb-[30px]">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  Text Messaging Consent
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6">
                  By opting into receive text messages, you agree to receive
                  messages from VLink, Inc. at the number you provided. Message
                  frequency may vary. Message and data rates may apply. Reply
                  “STOP” to unsubscribe. Reply “HELP” for assistance. Text
                  messaging opt-in data and consent will not be shared with
                  third parties.
                </p>
              </div>
              <div className="mb-[30px]">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  What Information is Collected on the Website?
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  We collect information to better serve our affiliates and
                  customers:
                </p>
                <ul className="list-disc pl-[22px]">
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    <b>General Visitors:</b> We collect non-personally
                    identifiable information such as pages visited on the site.
                    This information is used for internal marketing purposes and
                    does not include email addresses or individual IP addresses,
                    only business IPs.
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    <b>Affiliates:</b> We collect personally identifiable
                    information provided by affiliates through specific web
                    pages designed to collect membership information, such as
                    online questionnaires, resume submissions, job postings, and
                    applications for membership.
                  </li>
                </ul>
              </div>
              <div className="mb-[30px]">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  Do We Use “Cookies”?
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  A “cookie” is a small piece of data sent to a user’s computer
                  to identify them on subsequent visits. We use cookies only on
                  our message boards and chat software. On the message boards,
                  cookies confirm access rights. On chat platforms, cookies
                  identify returning visitors.
                </p>
              </div>
              <div className="mb-[30px]">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  How does the VLink website use Cookies and Other Tracking
                  Technologies?
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  VLink uses Cookies and Other Tracking Technologies to identify
                  you and your interests, to remember your preferences, and to
                  track your use of our website. We also use Cookies and Other
                  Tracking Technologies to control access to certain content on
                  our website, protect the website, and to process any of your
                  requests.
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  To administer our Sites and for research purposes, VLink has
                  contracted with third party service providers to track and
                  analyze statistical usage and volume information from our
                  website users. These third party service providers use cookies
                  to help us to improve the user experience, manage our Site
                  content, and analyze how users navigate and utilize the
                  website.
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  When you visit and browse our website, we automatically
                  collect data about you such as your email address and device
                  and browsing information and we use and share this data with
                  third party vendors in order to provide certain functionality
                  on our website and improve visitors&apos; experience, analyze
                  which pages you visited, measure advertising effectiveness,
                  and allow those third party vendors to improve their products
                  and services.
                </p>
                <ul className="list-disc pl-[22px]">
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    VLink, Inc. and its affiliates may access membership
                    information to communicate with affiliates and further the
                    organization’s mission.
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    We may make address information available to external
                    organizations to provide affiliates with relevant
                    information (excluding email addresses).
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    Requests for mailing lists by external organizations or
                    affiliates must be approved on a case-by-case basis, with a
                    commitment that the information will only be used for the
                    specific approved communication.
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    VLink, Inc. may share contact information of educational
                    session participants with corporate partners and faculty
                    serving at educational programs.
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    Recruiters and others may access resumes and contact
                    information stored in the online VLink, Inc. Resume Bank or
                    Application Tracking System.
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    Affiliates with log-in access to the Affiliates Only Area of
                    VLink, Inc. may view individual affiliate information
                    included in the online Affiliate Directory.
                  </li>
                  <li className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                    VLink, Inc. may contact affiliates and customers about
                    events, opportunities, and updates.
                  </li>
                </ul>
              </div>
              <div className="mb-[30px]">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  How Can Affiliates or Customers Opt Out of Receiving
                  Materials?
                </h4>
                <p className=" font-[400]resources md:text-[18px] text-[14px] leading-6 mb-3">
                  Any affiliate or customer who does not wish to be contacted by
                  VLink, Inc. or an organization with which we might share
                  contact information may notify us via email at
                  marketing@vlinkinfo.com or use the contact information below.
                  Affiliates and customers can opt out of specific email
                  communications or request to opt out of all mail and email
                  communications (except for basic membership and dues renewal
                  mailings). Affiliates may also manage their personal
                  information in the online Affiliate Directory and choose what
                  information will be accessible there.
                </p>
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  Do Not Sell My Personal Information
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  The CCPA gives California residents the right to opt-out from
                  the sale of Personal Information. We do not sell information
                  that directly identifies you. We do not exchange information
                  about you to third parties in exchange for money or other
                  consideration. We share information with third parties who
                  work with us, as explained on our General Privacy Policy, that
                  you may access above in our privacy policy, only for the
                  purposes described therein.
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  However, due to the broad definition of “sale” of Personal
                  Information under CCPA, including the provision of Personal
                  Information to another business or third party for monetary
                  and other valuable consideration, should you prefer for us not
                  to sell your Personal Information, please opt-out of the sale
                  of your Personal Information by contacting us at below contact
                  information or by completing our contact Form
                  (https://vlinkinfo.com/about-us/contact-us/) and typing in the
                  message box “Do Not Sell My Personal Information”. Please
                  consider we need this information in order to address your
                  request.
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  You may use an authorized agent to submit an opt-out request
                  on your behalf if you have provided the authorized agent
                  signed permission to do so. We may deny an opt-out request
                  from an agent that does not submit proof that they have been
                  authorized accordingly to act on your behalf. Otherwise, we
                  will fulfill your request within a reasonable time period in
                  accordance with applicable law.
                </p>
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  How Can Affiliates or Customers Review or Update Their
                  Information?
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  Affiliates and customers can update their information by
                  emailing marketing@vlinkinfo.com or using the contact
                  information below.
                </p>
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  How Can Affiliates, Customers, or Visitors Learn About Our
                  Security Practices?
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  We maintain reasonable security measures at our physical
                  facilities and web server to protect against the loss, misuse,
                  or alteration of information. To request information about our
                  security practices, please contact us using the information
                  below.
                </p>
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  How Can Affiliates or Customers Be Informed of Changes to the
                  Privacy Policy?
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  We may occasionally use collected information for new or
                  unanticipated uses not previously disclosed. If our
                  information collection and dissemination practices change, we
                  will update this Privacy Policy Statement and post the changes
                  on our website.
                </p>
              </div>
              <div className="">
                <h4 className="text-xl font-bold  text-[#000000] mb-4">
                  Contact Information
                </h4>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  For any questions or requests regarding this Privacy Policy,
                  please contact us:
                </p>
                <p className=" font-[400] md:text-[18px] text-[14px] leading-6 mb-3">
                  <b>Attention: VLink,</b> <br />
                  Address: 701 John Fitch Blvd, <br />
                  South Windsor, CT 06074 <br />
                  Phone: +1(860)247-1400 <br />
                  E-mail: marketing@vlinkinfo.com <br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
